import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import { useToast } from '../contexts/ToastContext';

interface ForgotPasswordResponse {
  ok: boolean;
}

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error('Ange e-post');
      return;
    }
    setLoading(true);
    try {
      await api.post<ForgotPasswordResponse>('/auth/request-password-reset', {
        email: email.trim(),
      });
      toast.info('Om kontot finns har en återställningslänk skickats via e-post');
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Kunde inte initiera återställning');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-4">
      <div className="w-full max-w-sm">
        <div className="h-10 flex items-center justify-center mb-6">
          <img src="/logga.png" alt="ApisAI" className="h-10 w-auto max-w-full" />
        </div>
        <h1 className="text-lg font-semibold mb-3">Glömt lösenord</h1>
        <form onSubmit={onSubmit} className="space-y-3">
          <input
            type="email"
            placeholder="E-post"
            className="w-full"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full py-1.5 px-3 bg-primary text-white rounded hover:bg-primary-hover disabled:opacity-50"
          >
            {loading ? 'Skickar...' : 'Återställ lösenord'}
          </button>
        </form>
        <p className="text-sm text-gray-600 mt-3">
          <Link to="/login" className="text-primary hover:underline">
            Tillbaka till login
          </Link>
        </p>
      </div>
    </div>
  );
}

